exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-item .nav-link a {\n  opacity: 0.25;\n}\n.nav-item .nav-link a:hover {\n  opacity: 1;\n}\n\n.parent-div {\n  display: flex;\n}\n\na {\n  text-decoration: none;\n}", ""]);

// exports
